import baseReportsLocal from 'moodleDir/procollege/lib/vue/default-block-root.vue';


export default {
  routes: [
    {
      path: '/',
      component:baseReportsLocal,
      name:'baseReportsLocal'
    },
  ]
};
